import React, { useEffect, useRef, useState } from 'react';
import SearchIcon from '../../components/icons/SearchIcon';

const SearchComponent = ({
  placeholder = 'Buscar...',
  defaultValue = '',
  value: controlledValue,
  debounceTime = 2000,
  inputClassName = '',
  mainContainerClassName = '',
  onChange
}) => {
  const inputRef = useRef(null);
  const isControlled = controlledValue !== undefined;
  const initialValue = isControlled ? controlledValue : defaultValue;
  const [value, setValue] = useState(initialValue);
  const [isInitializedComponent, setIsInitializedComponent] = useState(false);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    if (isControlled) {
      setValue(controlledValue);
    }
  }, [controlledValue]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, debounceTime);

    return () => {
      clearTimeout(handler);
    };
  }, [value, debounceTime]);

  useEffect(() => {
    setIsInitializedComponent(true);
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (onChange && isInitializedComponent) {
      onChange(debouncedValue);
    }
  }, [debouncedValue]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Ejecutar búsqueda inmediatamente al presionar Enter
      if (onChange && value !== debouncedValue) {
        onChange(value);
      }
    }
  };

  const mainContainerClass = [
    'tw-relative',
    'tw-w-full',
    'tw-flex',
    mainContainerClassName || ''
  ].join(' ');

  return (
    <div className={mainContainerClass}>
      <span className="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-4 tw-text-gray-400">
        <SearchIcon />
      </span>
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        {...(isControlled ? { value } : { defaultValue })}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className={`tw-w-full tw-pl-10 tw-pr-4 tw-py-1 tw-border tw-border-gray-200 tw-rounded-xl tw-bg-gray-50 tw-placeholder-gray-500 tw-max-h-12 tw-text-default ${inputClassName}`}
      />
    </div>
  );
};

export default SearchComponent;
